var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebinar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.7,15h-0.8c0.1-0.2,0.2-0.5,0.2-0.8V8.5c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v5.7 c0,0.4-0.2,0.7-0.5,0.7H6.7c-0.2,0-0.5-0.3-0.5-0.7v-8c0-0.4,0.2-0.7,0.5-0.7h9c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-9 C5.8,4.3,5,5.1,5,6.2v8c0,0.3,0.1,0.6,0.2,0.8H4.3c-0.9,0-1.5,0.9-1.5,1.9c0,1.1,0.7,1.9,1.5,1.9h16.5c0.9,0,1.5-0.9,1.5-1.9 C22.3,15.9,21.6,15,20.7,15 M20.7,17.7H4.3C4.2,17.7,4,17.5,4,17c0-0.5,0.2-0.7,0.3-0.7h16.5c0.1,0,0.3,0.3,0.3,0.7 C21,17.5,20.8,17.7,20.7,17.7 M8.9,9.6c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1C9.3,10.6,8.9,10.1,8.9,9.6 M11.4,9.6 c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1C11.8,10.6,11.4,10.1,11.4,9.6 M14.8,8.7c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1 c-0.5,0-1-0.4-1-1C13.9,9.1,14.3,8.7,14.8,8.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinar);
export default __webpack_public_path__ + "static/media/webinar.1a58a3b0cf4094b03bd25d1ac76c079c.svg";
export { ForwardRef as ReactComponent };